import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'

const INTERVALLO_ROTAZIONE_SECONDI = 7 // ogni quanto cambia sponsor nel banner, se ce n'è più di uno

async function segnaVisualizzazione(id) {
  try { await supabase.rpc('sponsor_incrementa_visualizzazione', { sponsor_id: id }) } catch {}
}
async function segnaClick(id) {
  try { await supabase.rpc('sponsor_incrementa_click', { sponsor_id: id }) } catch {}
}
function normalizzaLink(link) {
  if (!link) return null
  return /^https?:\/\//i.test(link) ? link : `https://${link}`
}

export default function SponsorBanner({ onVediTutti }) {
  const [listaSponsor, setListaSponsor] = useState([])
  const [indice, setIndice] = useState(0)

  useEffect(() => {
    const oggi = new Date().toISOString().split('T')[0]
    supabase.from('sponsor').select('*')
      .eq('attivo', true).lte('data_inizio', oggi).gte('data_fine', oggi)
      .order('ordine', { ascending: true })
      .then(({ data }) => setListaSponsor(data || []))
  }, [])

  useEffect(() => {
    if (listaSponsor.length <= 1) return
    const t = setInterval(() => setIndice(i => (i + 1) % listaSponsor.length), INTERVALLO_ROTAZIONE_SECONDI * 1000)
    return () => clearInterval(t)
  }, [listaSponsor])

  const s = listaSponsor[indice]

  // Conta una visualizzazione ogni volta che cambia lo sponsor mostrato nel banner
  useEffect(() => {
    if (!s) return
    segnaVisualizzazione(s.id)
  }, [s?.id])

  if (!s) return null

  function tapSponsor() {
    if (s.link) {
      segnaClick(s.id)
      window.open(normalizzaLink(s.link), '_blank', 'noopener,noreferrer')
    } else if (onVediTutti) {
      onVediTutti()
    }
  }

  return (
    <div style={{
      display: 'flex', alignItems: 'center', gap: 10,
      padding: '8px 14px', background: 'var(--surface)', borderTop: '1px solid var(--border)',
      flexShrink: 0,
    }}>
      <div onClick={tapSponsor} style={{ display: 'flex', alignItems: 'center', gap: 8, flex: 1, cursor: 'pointer', minWidth: 0 }}>
        <img src={s.immagine_url} alt={s.nome} style={{ width: 72, height: 72, borderRadius: 12, objectFit: 'cover', flexShrink: 0 }} />
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 9, color: 'var(--muted)', textTransform: 'uppercase', letterSpacing: 0.5 }}>Sponsor</div>
          <div style={{ fontSize: 12, fontWeight: 700, fontFamily: 'Syne', color: 'var(--text)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{s.nome}</div>
        </div>
      </div>
      {onVediTutti && (
        <>
          <div style={{ width: 1, alignSelf: 'stretch', background: 'var(--border)', flexShrink: 0 }} />
          <button onClick={onVediTutti} style={{
            background: 'none', border: 'none',
            color: 'var(--accent)', fontSize: 11, fontWeight: 800, fontFamily: 'Syne',
            cursor: 'pointer', flexShrink: 0, padding: '8px 4px', whiteSpace: 'nowrap',
          }}>
            Tutti →
          </button>
        </>
      )}
    </div>
  )
}
